// Regression: GitHub issue #111 — "Location Detail → Inventory tab: shows
// 'Inventory overview coming soon' placeholder despite header KPIs reporting
// Products = 15 and Stock Value = ₹899.5K".
//
// The Inventory tab now lists per-location stock; this helper classifies each
// row into in_stock / low_stock / out_of_stock so the table can render the
// matching status badge. Extracted so the rule can be regression-tested without
// pulling in React Query / DataTable.

export type StockStatus = 'in_stock' | 'low_stock' | 'out_of_stock';

export interface StockStatusInput {
  stock_quantity: number;
  /** null = no minimum: never low (C04). */
  low_stock_threshold: number | null;
}

export function classifyStockStatus(p: StockStatusInput): StockStatus {
  if (!Number.isFinite(p.stock_quantity) || p.stock_quantity <= 0) return 'out_of_stock';
  if (p.low_stock_threshold != null && Number.isFinite(p.low_stock_threshold) && p.stock_quantity <= p.low_stock_threshold) {
    return 'low_stock';
  }
  return 'in_stock';
}

export function stockValuePaise(p: { stock_quantity: number; cost: number }): number {
  const qty = Number.isFinite(p.stock_quantity) ? p.stock_quantity : 0;
  const cost = Number.isFinite(p.cost) ? p.cost : 0;
  return Math.round(qty * cost);
}
